module.exports = __webpack_public_path__ + "static/media/check-remaining-traffic_1.66f24fd8.png";